/**
 * Copyright © 2017, Rezo Zero
 *
 * @file EventEmitter.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

export default class EventEmitter {
    constructor () {
        this._triggers = {}
    }

    dispatchEvent (eventName, params) {
        const callbacks = this._triggers[eventName]

        if (callbacks && callbacks.length) {
            for (let callback of callbacks) {
                callback(params)
            }
        }
    }

    on (eventName, callback) {
        if (!this._triggers[eventName]) {
            this._triggers[eventName] = []
        }

        this._triggers[eventName].push(callback)
    }

    off (eventName, callbackToRemove) {
        const callbacks = this._triggers[eventName]

        if (callbacks && callbacks.length) {
            for (let i in callbacks) {
                if (callbacks.hasOwnProperty(i)) {
                    const callback = callbacks[i]
                    if (callback === callbackToRemove) {
                        callbacks.splice(i, 1)
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./webpack/js/utils/EventEmitter.js